import {
  Component,
  OnInit,
  Input,
  OnDestroy,
} from '@angular/core';
import {
  LoadingController,
  Platform,
} from '@ionic/angular';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';

import { Sale } from '../../../models/sale/sale.model';
import { Payment } from '../../../models/payment/payment.model';
import { Stylist } from '../../../models/stylist/stylist.model';
import { Tip } from '../../../models/tip/tip.model';
import { SaleCheckOutCallBackData } from '../sale-checkout.page';
import {
  SALE_CHECKOUT_TYPE,
  SaleService,
} from '../../../services/sale.service';
import {
  SquareTransaction,
  SquarePOSService,
} from '../../../services/square-pos.service';
import { CustomValidator } from '../../../utilities/custom-validator';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { AlertService } from '../../../utilities/alert.service';
import { ToastService } from '../../../utilities/toast.service';
import { switchMap } from 'rxjs/operators';
import { Salon } from '../../../models';
import { NavigationStateService } from '../../../services/navigation-state.service';
declare var posthog: any;
@Component({
  selector: 'app-sale-confirmation',
  templateUrl: './sale-confirmation.page.html',
  styleUrls: ['./sale-confirmation.page.scss'],
})
export class SaleConfirmationPage implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() grandTotal: string;
  @Input() merchantReferenceID: string;
  @Input() tip: string;
  public data: any;
  public sale: Sale;
  public from: string = ""; 
  public completed: boolean;

  public checkOutPromise: Function;

  public checkOutType: SALE_CHECKOUT_TYPE;

  public emailForm: UntypedFormGroup;

  public emailField: UntypedFormControl;

  public phoneField: UntypedFormControl;

  public clientEmailCheckBox: UntypedFormControl;

  public clientPhoneCheckBox: UntypedFormControl;

  public submitted: boolean;

  public transactionID: string;

  public isCapacitor: boolean;

  public receiptHTML: string;

  public isFromBookings: boolean;
  public isFromRegisterClosure
  public salon: Salon;
  public navigationStateSubscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private saleService: SaleService,
    private squarePOSService: SquarePOSService,
    private printer: Printer,
    private platform: Platform,
    private router: Router,
    private readonly alertService: AlertService,
    private readonly toastService: ToastService,
    private loadingCtrl: LoadingController,
    private userService: UserService,
    private navigationStateService: NavigationStateService
  ) {
    this.isCapacitor = this.platform.is('capacitor');
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.sale = state.sale;
      this.checkOutType = state.checkOutType;
      this.isFromBookings = state.isFromBookings;
      this.isFromRegisterClosure = state.isFromRegisterClosure;
      this.from = state.from;
    });

    let clientEmail: string = this.sale.getClient()
      ? this.sale.getClient().email
      : '';

    let clientPhone2: string = this.sale.getClient()
      ? this.sale.getClient().phone2
      : '';
    this.clientEmailCheckBox = new UntypedFormControl(
      CustomValidator.isEmailValid(clientEmail)
    );
    this.clientPhoneCheckBox = new UntypedFormControl(
      !CustomValidator.isEmailValid(clientEmail) &&
        CustomValidator.isPhoneValid(clientPhone2)
    );
    this.emailField = new UntypedFormControl(
      clientEmail,
      Validators.compose([CustomValidator.validateEmail])
    );

    this.salon = userService.getSalon().clone();
    const countryID = this.salon.getCountry().id; 

    this.phoneField = new UntypedFormControl(
      clientPhone2,
      Validators.compose([CustomValidator.validatePhone(countryID)])
    );

    this.emailForm = this.formBuilder.group({
      clientEmailCheckBox: this.clientEmailCheckBox,
      clientPhoneCheckBox: this.clientPhoneCheckBox,
      email: this.emailField,
      phone: this.phoneField,
    });
  }

  public async ngOnInit() {
    console.log(this.isFromRegisterClosure)
    this.checkOutPromise = this.saleService.getCheckOutPromise();
    this.checkOutType = this.saleService.getCheckOutType();

    if (this.sale) {
      if (this.checkOutType === SALE_CHECKOUT_TYPE.SquarePOS) {
        // Square returns a "data" object
        //const squareResponseData = this.navParams.get('data') ? JSON.parse(decodeURIComponent(this.navParams.get('data'))) : {};
        const squareResponseData = this.data
          ? JSON.parse(decodeURIComponent(this.data))
          : {};


        const transactionID: string = squareResponseData['transaction_id'];
        const clientTransactionID: string =
          squareResponseData['transaction_id'];

        // "ok" or "error"
        const paymentStatus: string = squareResponseData['status'];

        const errorCode: string = squareResponseData['error_code'];

        if (paymentStatus !== 'ok') {
          return false;
        }

        if (errorCode) {
          this.squarePOSService.handleError(errorCode).subscribe({
            next: (result) => {},
            error: (e) => {
              this.alertService.presentErrorAlert();
            },
          });

          return false;
        } else {
          this.transactionID = transactionID;
        }
      } else if (this.checkOutType === SALE_CHECKOUT_TYPE.PaypalHere) {
        const paymentType: string = this.type;
        const grandTotal: string = this.grandTotal;
        const merchantReferenceID: string = this.merchantReferenceID;
        const tip: string = this.tip;

        // source: https://github.com/paypal/here-sideloader-api-samples/blob/master/docs/README.md
        // Paypal returns UNKNOWN if the payment has been cancelled/declined
        // note: it returns UNKNOWN/unknown depending on the platform (legacy code)
        if (paymentType && paymentType.toLowerCase() !== 'unknown') {
        }

        return false;
      } else if (this.checkOutType === SALE_CHECKOUT_TYPE.salonMonsterPay) {
      } else {
        // unsupported checkout type
        return false;
      }
    } else {
      setTimeout(() => {
        //this.navCtrl.setRoot("SaleManagerPage");
        this.router.navigateByUrl('/sales');
      }, 100);

      return false;
    }

    if (this.checkOutType === SALE_CHECKOUT_TYPE.SquarePOS) {
      setTimeout(this.loadSquareTransaction, 1000);
    } else {
      this.initiateSaving();
    }
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }
  // public ngOnInit () {

  //   if (this.checkOutType === SALE_CHECKOUT_TYPE.SquarePOS) {
  //     setTimeout(this.loadSquareTransaction, 1000);
  //   } else {
  //     this.initiateSaving();
  //   }
  // }

  public close() {
    //this.navCtrl.popToRoot()
    if (this.isFromBookings|| this.from == "/bookings") {
      this.router.navigateByUrl('/bookings').then(() => {
        if (this.checkOutPromise) {
          const data: SaleCheckOutCallBackData = {
            sale: this.sale,
            action: 'save',
            // ,
            // viewReceipt: viewReceipt
          };

          this.checkOutPromise(data);
        }
        posthog.capture('Sale Saved', { clientFirstName: this.sale.client.firstName, clientLastName: this.sale.client.lastName, amount: this.sale.paymentsTotal, emailed: false })
        this.toastService.presentSimpleToast(`Sale completed successfully`, 3000);
      });
    } else if (this.isFromRegisterClosure) {
      this.router.navigateByUrl(`/register-closures/${this.isFromRegisterClosure}`)
    } else {
      this.router.navigateByUrl('/sales').then(() => {
        if (this.checkOutPromise) {
          const data: SaleCheckOutCallBackData = {
            sale: this.sale,
            action: 'save',
            // ,
            // viewReceipt: viewReceipt
          };

          this.checkOutPromise(data);
        }
        this.toastService.presentSimpleToast(`Sale completed successfully`, 3000);
      });
    }
  }

  public testingStuff() {
  }

  public loadSquareTransaction = () => {

    if (this.transactionID.length > 1) {
      this.squarePOSService
        .fetchTransactionDetails(
          this.transactionID,
          this.squarePOSService.getSquareBusinessLocation().id
        )
        .subscribe({
          next: (transaction: SquareTransaction) => {

            // sample response
            // {"id":"nAX4IwlnQSdD6R0sgAu24o5eV","location_id":"RE23A053B7K58","created_at":"2019-01-21T04:49:55Z","tenders":[{"type":"CASH","id":"LkA6Hdv1rhqXLaIlY1ykKQB","location_id":"RE23A053B7K58","transaction_id":"nAX4IwlnQSdD6R0sgAu24o5eV","created_at":"2019-01-21T04:49:55Z","amount_money":{"amount":5840,"currency":"CAD"},"processing_fee_money":{"amount":0,"currency":"CAD"},"cash_details":{"buyer_tendered_money":{"amount":5840,"currency":"CAD"},"change_back_money":{"amount":0,"currency":"CAD"}}}],"product":"REGISTER","client_id":"2EBC6024-E684-4F33-9DA9-4AC64BAA7074"}
            // this.sale = this.sale.addPayment(this.squarePOSService.paymentToBeAddedOnSuccess);

            for (let tender of transaction.tenders) {
              const tenderType: string = tender.type;
              let payment: Payment = new Payment({
                id: undefined,
                name: '',
                type: 1, // Temporary
                amount: 0, // Temporary
              });

              if (tender.amount_money) {
                let amount: number = tender.amount_money.amount;

                if (amount > 0) {
                  amount = tender.amount_money.amount / 100;
                }

                payment = payment.setAmount(amount);
              }

              if (tenderType === 'CASH') {
                payment = payment.setType(1);
              } else if (tenderType === 'CARD') {
                if (tender.card_details && tender.card_details.card) {
                  const cardBrand: string = tender.card_details.card.card_brand;

                  // TODO: missing DEBIT
                  if (cardBrand === 'VISA') {
                    payment = payment.setType(3);
                  } else if (cardBrand === 'MASTERCARD') {
                    payment = payment.setType(4);
                  } else if (cardBrand === 'AMERICAN_EXPRESS') {
                    payment = payment.setType(5);
                  } else {
                    // else set it the "Square"
                    // DEBIT
                    payment = payment.setType(11);
                  }
                }
              } else {
                payment = payment.setType(11);
              }

              if (tender.tip_money) {
                let amount: number = tender.tip_money.amount;

                if (amount > 0) {
                  amount = tender.tip_money.amount / 100;
                }

                let stylist: Stylist;
                this.sale.lineitems.some((lineitem) => {
                  if (lineitem.getStylist()) {
                    stylist = lineitem.getStylist();
                    return true;
                  }

                  return false;
                });

                const tipObj: Tip = new Tip({
                  id: undefined,
                  stylistID: stylist ? stylist.getID() : undefined,
                  stylist: stylist,
                  value: amount,
                  isRefunded: 0,
                });

                this.sale = this.sale.addTip(tipObj);
              }

              this.sale = this.sale.addPayment(payment);
            }

            this.initiateSaving();
          },
          error: (e) => {
            // this.navCtrl.pop().then(() => {
            this.router.navigateByUrl('/email-receipt').then(() => {
              //this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig()).present();
              this.alertService.presentErrorAlert();
            });
          },
        });
    } else {
      let payment: Payment = new Payment({
        id: undefined,
        name: '',
        type: 1, // Cash
        amount: 0, // Temporary
      });
      this.sale = this.sale.addPayment(payment);
      this.initiateSaving();
    }
  };

  public async sendReceipt() {
    this.submitted = true;

    if (!this.emailForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();

    this.saleService.sendReceipt(this.sale, this.emailField.value).subscribe({
      next: (data) => {
        loader.dismiss().then(() => {
          posthog.capture('Sale Saved', { clientFirstName: this.sale.client.firstName, clientLastName: this.sale.client.lastName, amount: this.sale.paymentsTotal, emailed: true })
          this.close();
        });
      },
      error: (e) => {
        console.error(e)
        loader.dismiss().then(() => {
          this.alertService.presentErrorAlert();
        });
      },
    });
  }

  public printReceipt() {
    if (this.isCapacitor) {
      const options: PrintOptions = {
        name: 'salonMonster Receipt',
        duplex: true,
      };

      this.printer.print(this.receiptHTML, options).then(
        () => {},
        () => {}
      );
    } else {
      // source: https://www.linkedin.com/pulse/create-print-component-angular2-which-user-defined-html-rajesh-g
      if (window) {
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
          const popup = window.open(
            '',
            '_blank',
            'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,' +
              'location=no,status=no,titlebar=no'
          );

          popup.window.focus();
          popup.document.write(
            `<!DOCTYPE html><body onload="window.print()">${this.receiptHTML}</html>`
          );

          //  popup.document.write('<!DOCTYPE html><html><head>  '
          // +'<link rel="stylesheet" href="node_modules/bootstrap/dist/css/bootstrap.css" '
          // +'media="screen,print">'
          // +'<link rel="stylesheet" href="style.css" media="screen,print">'
          // +    '</head><body onload="window.print()"><div class="reward-body">'
          // + this.receiptHTML + '</div></html>');

          popup.onbeforeunload = function (event) {
            popup.close();
            return '.\n';
          };
          popup.onabort = function (event) {
            popup.document.close();
            popup.close();
          };

          popup.document.close();
        } else {
          const popup = window.open('', '_blank', 'width=800,height=600');
          popup.document.open();
          popup.document.write(
            `<html><body onload="window.print()">${this.receiptHTML}</html>`
          );
          popup.document.close();
        }
      }
    }

    return true;
  }

  private initiateSaving() {
    let clientEmail: string = '';

    this.sale.lineitems.some((lineitem) => {
      if (
        lineitem.getClient() &&
        CustomValidator.isEmailValid(lineitem.getClient().email)
      ) {
        clientEmail = lineitem.getClient().email;
        return true;
      }

      return false;
    });

    this.emailField = new UntypedFormControl(
      clientEmail,
      Validators.compose([Validators.required, CustomValidator.validateEmail])
    );

    if (this.sale.isSaleReadyForCheckOut()) {
      this.sale = this.sale.setStatus(1);
      this.saleService
        .save(this.sale)
        .pipe(
          switchMap((sale) => {
            this.sale = sale;
            return this.saleService.fetchReceiptHTML(this.sale);
          })
        )
        .subscribe({
          next: (receiptHTML) => {
            this.receiptHTML = receiptHTML;
            this.completed = true;
            // this.changeDetectorRef.detectChanges();
          },
          error: (e) => {
            // const alert = this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig());
            this.alertService.presentErrorAlert();
            // this.alertService.onDidDismiss(() => {this.navCtrl.pop();});
            // alert.present();
          },
        });
    } else {
      //this.navCtrl.pop();
      this.router.navigateByUrl('/sales');
    }
  }
}
